import { useDispatch, useSelector } from 'react-redux'
import type { RootState, StoreDispatch } from 'store'
import { createSelector } from '@reduxjs/toolkit'

export const useStoreDispatch = useDispatch.withTypes<StoreDispatch>()
export const useStoreSelector = useSelector.withTypes<RootState>()
export const createStoreSelector = createSelector.withTypes<RootState>()
